import { render, staticRenderFns } from "./DocumentSimpleNewOrEdit.vue?vue&type=template&id=005f2a1f&scoped=true&"
import script from "./DocumentSimpleNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentSimpleNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSimpleNewOrEdit.vue?vue&type=style&index=0&id=005f2a1f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f2a1f",
  null
  
)

export default component.exports